import React, {useContext, useEffect, useState} from 'react';
import logo from "../assets/images/colzones-logo-256px.png";
import DivisionServiceAPI from "../services/api/divisionApi";
import {useHistory} from "react-router-dom";
import {MapContext} from "../context/MapContext";

const Home = () => {
    const [divisions, setDivisions] = useState(null)
    const [divisionSelected, setDivisionSelected] = useState(null)
    const {mapContext, dispatch} = useContext(MapContext);
    const history = useHistory();

    useEffect(() => {

        try {
            (async () => {
                let data = await DivisionServiceAPI.getDivisions('', {});
                data && setDivisions(data.data);
                mapContext &&
                mapContext.divisionData &&
                setDivisionSelected(mapContext.divisionData.id || null)
            })();
        } catch (e) {
            console.log(e)
        }
    }, [mapContext]);

    const selectDivision = (divisionSelected) => {
        try {
            if (divisionSelected && divisionSelected !== -1) {
                for (let divisionData of divisions) {
                    divisionData.json_data.id === parseInt(divisionSelected)
                    && dispatch({type: 'SELECT_DIVISION', divisionData: divisionData.json_data || null});
                }
                history.push(`/chantiers/${divisionSelected}`)
            }
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className="colored-container container-fluid">
            <div className={'logo-home'}>
                <img src={logo} alt={'Colzones'} className={'img-fluid'}/>
            </div>
            <h1 className={'title-home title-text-center-invert'}>Se connecter</h1>
            <div className={'menu-home'}>
                <div className={'row justify-content-center'}>
                    <div className="form-group col-10 col-lg-8">
                        <select className="form-control" id="select-ue" value={divisionSelected || '-1'}
                                onChange={e => setDivisionSelected(e.target.value)}
                        >
                            <option value='-1' disabled>Choisir votre UE</option>
                            {
                                divisions && divisions
                                    .sort((a, b) => a.json_data.name.localeCompare(b.json_data.name))
                                    .map((division, index) => (
                                        <option key={index}
                                                value={division.json_data.id}>{division.json_data.name}</option>
                                    ))
                            }
                        </select>
                    </div>
                </div>
                <div className={'row justify-content-center'}>
                    <button
                        type="button" className="btn btn-danger btn-block col-10 col-lg-8"
                        onClick={() => {
                            selectDivision(divisionSelected)
                        }}
                    >
                        Se connecter
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Home;